import { PublicClientApplication } from '@azure/msal-browser';

export const msalInstance = new PublicClientApplication({
 auth: {
   clientId: process.env.REACT_APP_CLIENT_ID,
   authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}`,
   redirectUri: getRedirectUri()
 },
});
function getRedirectUri() {
  const currentUrl = window.location.href;
  if (currentUrl.includes("localhost")) {
      return "http://localhost:3000"; // Set redirectUri to localhost
  } else if (currentUrl.includes("https://qa.cmiportal.nielseniq.io/")) {
      return "https://qa.cmiportal.nielseniq.io/"; // Set redirectUri to https://qa.cmiportal.nielseniq.io/
  } else if (currentUrl.includes("https://uat.cmiportal.nielseniq.io/")) {
      return "https://uat.cmiportal.nielseniq.io/"; // Set redirectUri to https://uat.cmiportal.nielseniq.io/
  }
   else if (currentUrl.includes("https://cmiportal.nielseniq.com/")) {
      return "https://cmiportal.nielseniq.com/"; // PROD1 Set redirectUri to https://cmiportal.nielseniq.com/
  } else if (currentUrl.includes("https://cmiportal.nielseniq.cn/")) {
      return "https://cmiportal.nielseniq.cn/"; // PROD4 Set redirectUri to https://cmiportalcn.nielseniq.cn/
  } else {
      // Set a default redirectUri if none of the conditions are met
      return "https://qa.cmiportal.nielseniq.io/";
      // return "http://localhost:3000";
  }
}